import { render } from "./ErrorModal.vue?vue&type=template&id=6427619f"
import script from "./ErrorModal.vue?vue&type=script&lang=ts"
export * from "./ErrorModal.vue?vue&type=script&lang=ts"
script.render = render

export default script